import { queryOptions } from "@tanstack/react-query";
import { productAPIClient } from "../productAPIClient";
import { PRODUCT_KEYS } from "./keys";

// Product catalogue detail barely moves and the facade caches this route for 10 minutes anyway.
const PRODUCTS_STALE_TIME_MS = 10 * 60 * 1000;

export const PRODUCT_QUERIES = {
  bySkus: (skus: string[]) =>
    queryOptions({
      queryKey: PRODUCT_KEYS.bySkus(skus),
      queryFn: () => productAPIClient.getProductsBySkus(skus),
      staleTime: PRODUCTS_STALE_TIME_MS,
      enabled: skus.length > 0,
    }),
};
